export default function formatDateToSQL(date){
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}